// Doc-Ref: docs/features/collaborations-plan.md
import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getGeneralOverview = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/overview`; // User provided /explore/collaborations/overview, but usually AxiosConfigExplore has /explore base url.
  // Wait, let's just use what user provided exactly.
  return axios.get(url, { params }).then((res) => res.data);
};

export const getCurrentCollaborationFacts = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/current-collaborations/facts`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getCurrentCollaborationTable = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/current-collaborations/table`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getCurrentCollaborationMap = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/current-collaborations/map`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getCurrentCollaborationNetwork = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/current-collaborations/network`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getPotentialCollaborations = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/potential-collaborations`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getCandidateMetrics = (candidateId, params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/potential-collaborations/candidates/${candidateId}/metrics`;
  return axios.get(url, { params }).then((res) => res.data);
};

// Deprecated job-based functions kept for backward compatibility
export const triggerPotentialCollaborationJob = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/potential-collaborations/jobs`;
  return axios.post(url, null, { params }).then((res) => res.data);
};

export const pollPotentialCollaborationJobStatus = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/potential-collaborations/jobs/status`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getPotentialCollaborationData = (params) => {
  return getPotentialCollaborations(params);
};

export const recomputePotentialCollaborationJob = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/potential-collaborations/jobs/recompute`;
  return axios.post(url, null, { params }).then((res) => res.data);
};

export const getSuggestedKeywords = (params) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/suggested-keywords`;
  return axios.get(url, { params }).then((res) => res.data);
};

export const getGeneralSocialImpact = (params, config = {}) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/social_impact`;
  return axios.get(url, { params, ...config }).then((res) => res.data);
};

export const getGeneralSocialImpactDetail = (sdgNum, params, config = {}) => {
  const axios = AxiosConfigExplore();
  const url = `/collaborations/social_impact/${sdgNum}`;
  return axios.get(url, { params, ...config }).then((res) => res.data);
};

